// extracted by mini-css-extract-plugin
export default {"closeSnackBarBtn":"app_closeSnackBarBtn__Acx4f","notice":"app_notice__ljxzQ","unselectable":"app_unselectable__Jjn4Q"};